import type { AguardandoEntregaItem } from "../../../services/aguardandoEntregaService";
import type { PainelFinalizadoItem } from "../../../services/painelService";
import { BrazilDate } from "../../../utils/BrazilDate";

export function agruparItensEntregaPorPedido(
  items: AguardandoEntregaItem[]
): AguardandoEntregaItem[][] {
  const map = new Map<number, AguardandoEntregaItem[]>();
  for (const item of items) {
    const grupo = map.get(item.displayId);
    if (grupo) grupo.push(item);
    else map.set(item.displayId, [item]);
  }
  const grupos = Array.from(map.values());
  grupos.sort(
    (a, b) => (a[0]?.displayId ?? 0) - (b[0]?.displayId ?? 0)
  );
  return grupos;
}

function maxFinalizadoEm(grupo: PainelFinalizadoItem[]): number {
  let max = 0;
  for (const item of grupo) {
    const t = new Date(item.finalizadoEm).getTime();
    if (t > max) max = t;
  }
  return max;
}

export function agruparFinalizadosPorPedido(
  items: PainelFinalizadoItem[]
): PainelFinalizadoItem[][] {
  const map = new Map<number, PainelFinalizadoItem[]>();
  for (const item of items) {
    const grupo = map.get(item.displayId);
    if (grupo) grupo.push(item);
    else map.set(item.displayId, [item]);
  }
  const grupos = Array.from(map.values());
  grupos.sort((a, b) => maxFinalizadoEm(b) - maxFinalizadoEm(a));
  return grupos;
}

export function contarProntosEntrega(itens: AguardandoEntregaItem[]): {
  prontas: number;
  total: number;
  todosProntos: boolean;
} {
  const principal = itens[0];
  if (!principal) {
    return { prontas: 0, total: 0, todosProntos: false };
  }
  return {
    prontas: principal.unidadesProntas,
    total: principal.unidadesTotal,
    todosProntos: principal.prontoParaEntrega,
  };
}

export function dataInicioAguardandoEntregaPedido(
  itens: AguardandoEntregaItem[]
): string | null {
  const { todosProntos } = contarProntosEntrega(itens);
  if (!todosProntos) return null;

  let maxMs = 0;
  let maxIso: string | null = null;
  for (const item of itens) {
    const ms = BrazilDate.parseAsBrazil(item.dataInicio).getTime();
    if (!Number.isNaN(ms) && ms >= maxMs) {
      maxMs = ms;
      maxIso = item.dataInicio;
    }
  }
  return maxIso;
}

export function nomesUnicos(
  valores: (string | null | undefined)[]
): string[] {
  const unicos = new Set<string>();
  for (const valor of valores) {
    const nome = valor?.trim();
    if (nome) unicos.add(nome);
  }
  return Array.from(unicos);
}
